import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import * as MessageTypes from 'automation-ui-canvas/constants/MessageTypes';
import * as AlertTypes from 'automation-ui-canvas/constants/AlertTypes';
import * as FriendlyErrors from 'automation-ui-canvas/constants/FriendlyErrors';
import { jsx as _jsx } from "react/jsx-runtime";
function getBodyWithRefreshLink(message) {
  return () => {
    const refreshLink = /*#__PURE__*/_jsx(UILink, {
      onClick: () => window.location.reload(),
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${message}.pageLink`
      })
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `${message}.body`,
      options: {
        pageLink: refreshLink
      }
    });
  };
}
const AlertDefinitions = {
  [AlertTypes.DEFAULT]: {
    title: 'alerts.defaultAlert.title',
    type: MessageTypes.WARN
  },
  [AlertTypes.SAVED_WORKFLOW_FAILED]: {
    title: 'alerts.workflowSaveFailed.title',
    body: 'alerts.workflowSaveFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.SAVED_WORKFLOW_ENROLLMENT_FAILED]: {
    title: 'alerts.workflowEnrollmentSaveFailed.title',
    body: messageOptions => {
      if (messageOptions.message && messageOptions.message.includes('number properties must be provided with a valid whole number value to filter on')) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "alerts.workflowEnrollmentSaveFailedDecimalValues.body"
        });
      }
      if (messageOptions.errorSubCategory === FriendlyErrors.TOO_MANY_ASSOCIATION_FILTERS) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "alerts.workflowEnrollmentSaveFailedMaxAssocationFilters.body"
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "alerts.workflowEnrollmentSaveFailed.body"
      });
    },
    type: MessageTypes.DANGER
  },
  [AlertTypes.SAVED_GENERAL_SETTINGS_SUCCESS]: {
    title: 'alerts.savedSettingsSuccess.title',
    body: 'alerts.savedSettingsSuccess.general',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.SAVED_UNENROLLMENT_SETTINGS_SUCCESS]: {
    title: 'alerts.savedSettingsSuccess.title',
    body: 'alerts.savedSettingsSuccess.unenrollment',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.SAVED_ACTION_SET_SUCCESS]: {
    title: 'alerts.savedActionSetsSuccess.title',
    body: 'alerts.savedActionSetsSuccess.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.CREATED_ENROLLMENT_SUCCESS]: {
    title: messageOptions => {
      return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "alerts.enrollObjectSuccess.title_cob",
        objectTypeId: messageOptions.objectTypeId
      });
    },
    body: messageOptions => {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: messageOptions.message,
        options: messageOptions.options,
        elements: messageOptions.elements
      });
    },
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.CREATED_PLATFORM_ENROLLMENT_SUCCESS]: {
    title: 'alerts.enrollPlatformSuccess.title',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.EXPORT_WORKFLOW_SUCCESS]: {
    title: 'alerts.exportWorkflowSuccess.title',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.DELETE_WORKFLOW_FAILED]: {
    title: 'alerts.defaultAlert.title',
    body: 'alerts.deleteWorkflowFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CLONE_WORKFLOW_FAILED]: {
    title: 'alerts.cloneWorkflowFailed.title',
    body: 'alerts.cloneWorkflowFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CREATE_WORKFLOW_FAILED]: {
    title: 'alerts.createWorkflowFailed.title',
    body: 'alerts.createWorkflowFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CREATE_FROM_TEMPLATE_FAILED]: {
    title: 'alerts.createFromTemplateFailed.title',
    body: 'alerts.createFromTemplateFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.DISABLED_WITH_NO_ACTIONS]: {
    title: 'alerts.automaticallyDisableEmptyWorkflow.title',
    body: 'alerts.automaticallyDisableEmptyWorkflow.body',
    type: MessageTypes.WARN
  },
  [AlertTypes.CLONE_FILTER_PROPERTY_TYPE_HAS_CHANGED]: {
    title: 'alerts.cloneFilterPropertyTypeHasChanged.title',
    body: 'alerts.cloneFilterPropertyTypeHasChanged.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CREATE_FILTER_PROPERTY_TYPE_HAS_CHANGED]: {
    title: 'alerts.createFilterPropertyTypeHasChanged.title',
    body: 'alerts.createFilterPropertyTypeHasChanged.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CLONE_WORKFLOW_NAME_LENGTH_INVALID]: {
    title: 'alerts.cloneWorkflowNameLengthInvalid.title',
    body: 'alerts.cloneWorkflowNameLengthInvalid.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CREATE_WORKFLOW_NAME_LENGTH_INVALID]: {
    title: 'alerts.createWorkflowNameLengthInvalid.title',
    body: 'alerts.createWorkflowNameLengthInvalid.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.WORKFLOW_HAS_VALIDATION_ERRORS]: {
    title: 'alerts.enrollmentTestFailedValidation.title',
    body: 'alerts.enrollmentTestFailedValidation.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.DELETED_FOLDER]: {
    title: 'alerts.deletedFolder.title',
    body: 'alerts.deletedFolder.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.DELETED_FOLDER_FAILED]: {
    title: 'alerts.deletedFolderFailed.title',
    body: 'alerts.deletedFolderFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.DELETED_FOLDER_TEAM_CONTENT_FAILED]: {
    title: 'alerts.deletedFolderTeamContentFailed.title',
    body: 'alerts.deletedFolderTeamContentFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.UPDATED_FOLDER_CONTENTS]: {
    title: 'alerts.updatedFolderContents.title',
    body: 'alerts.updatedFolderContents.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.UPDATED_FOLDER_CONTENTS_ROOT]: {
    title: 'alerts.updatedFolderContentsRoot.title',
    body: 'alerts.updatedFolderContentsRoot.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.MOVE_FLOW_TO_FOLDER_AFTER_CREATE_FAILED]: {
    title: 'alerts.moveFlowToFolderAfterCreateFailed.title',
    body: 'alerts.moveFlowToFolderAfterCreateFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.UPDATED_FOLDER_CONTENTS_FAILED]: {
    title: 'alerts.updatedFolderContentsFailed.title',
    body: 'alerts.updatedFolderContentsFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.UPDATED_FOLDER_CONTENTS_FAILED_ROOT]: {
    title: 'alerts.updatedFolderContentsFailedRoot.title',
    body: 'alerts.updatedFolderContentsFailedRoot.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.CREATED_FOLDER]: {
    title: 'alerts.createdFolder.title',
    body: 'alerts.createdFolder.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.CREATE_FOLDER_FAILED]: {
    title: 'alerts.createFolderFailed.title',
    body: 'alerts.createFolderFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.LIVE_UPDATE_TO_PLATFORM_HYBRID]: {
    title: 'alerts.liveUpdateToPlatformHybrid.title',
    body: 'alerts.liveUpdateToPlatformHybrid.body',
    type: MessageTypes.DANGER,
    closeable: false
  },
  [AlertTypes.UPDATED_EXECUTION_TIME_SETTINGS_META]: {
    title: 'alerts.updatedExecutionTimeSettingsMeta.title',
    body: 'alerts.updatedExecutionTimeSettingsMeta.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.UPDATED_EXECUTION_TIME_SETTINGS_META_FAILED]: {
    title: 'alerts.updatedExecutionTimeSettingsMetaFailed.title',
    body: 'alerts.updatedExecutionTimeSettingsMetaFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_SUCCESS]: {
    title: 'alerts.updatedWorkflowNotificationsSettings.title',
    body: 'alerts.updatedWorkflowNotificationsSettings.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.WORKFLOW_NOTIFICATIONS_SETTINGS_SAVING_FAIL]: {
    title: 'alerts.updatedWorkflowNotificationsSettingsFailed.title',
    body: 'alerts.updatedWorkflowNotificationsSettingsFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.WORKFLOW_METRICS_TOGGLE_SETTINGS_SAVING_FAIL]: {
    title: 'alerts.updatedWorkflowMetricsToggleSettingsFailed.title',
    body: 'alerts.updatedWorkflowMetricsToggleSettingsFailed.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.OUTDATED_FLOW_VERSION]: {
    title: `alerts.${FriendlyErrors.OUTDATED_FLOW_VERSION}.title`,
    body: getBodyWithRefreshLink(`alerts.${FriendlyErrors.OUTDATED_FLOW_VERSION}`),
    type: MessageTypes.DANGER
  },
  [AlertTypes.DELETED_ACTION_FAILED]: {
    title: `alerts.FlowUpdateError.DELETED_ACTION_FAILED.title`,
    body: getBodyWithRefreshLink(`alerts.FlowUpdateError.DELETED_ACTION_FAILED`),
    type: MessageTypes.DANGER
  },
  [AlertTypes.UPDATE_ACTION_FAILED]: {
    title: `alerts.FlowUpdateError.UPDATE_ACTION_FAILED.title`,
    body: getBodyWithRefreshLink(`alerts.FlowUpdateError.UPDATE_ACTION_FAILED`),
    type: MessageTypes.DANGER
  },
  [AlertTypes.UPDATE_REFERENCED_ACTION_FAILED]: {
    title: `alerts.FlowUpdateError.UPDATE_REFERENCED_ACTION_FAILED.title`,
    body: getBodyWithRefreshLink(`alerts.FlowUpdateError.UPDATE_REFERENCED_ACTION_FAILED`),
    type: MessageTypes.DANGER
  },
  [AlertTypes.TEAM_ASSIGN_SUCCESS]: {
    title: `alerts.teamAssignSuccess.title`,
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.TEAM_ASSIGN_FAIL]: {
    title: `alerts.teamAssignFail.title`,
    type: MessageTypes.DANGER
  },
  [AlertTypes.TEAM_ASSIGN_FAIL_PERMISSION_DENIED]: {
    title: 'alerts.teamAssignFailPermissionDenied.title',
    body: 'alerts.teamAssignFailPermissionDenied.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.LOAD_RESOURCES_FAILED]: {
    title: 'alerts.loadResourcesFailed.title',
    body: getBodyWithRefreshLink('alerts.loadResourcesFailed'),
    type: MessageTypes.DANGER
  },
  [AlertTypes.EVENT_ENROLLMENT_BETA_OPT_IN_FAILURE]: {
    title: 'alerts.eventEnrollmentOptInFailure.title',
    body: 'alerts.eventEnrollmentOptInFailure.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.EVENT_ENROLLMENT_BETA_OPT_OUT_FAILURE]: {
    title: 'alerts.eventEnrollmentOptOutFailure.title',
    body: 'alerts.eventEnrollmentOptOutFailure.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.COPY_NOT_SUPPORTED]: {
    title: 'alerts.copy.notSupported.title',
    body: 'alerts.copy.notSupported.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.PASTE_FAILED]: {
    title: 'alerts.paste.genericError.title',
    body: 'alerts.paste.genericError.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.PASTE_NO_ACTION_FAILURE]: {
    title: 'alerts.paste.noActionError.title',
    body: 'alerts.paste.noActionError.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.PASTE_OBJECT_MISMATCH_FAILURE]: {
    title: 'alerts.paste.objectTypeMismatch.title',
    body: 'alerts.paste.objectTypeMismatch.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.PASTE_ACTION_MISMATCH_FAILURE]: {
    title: 'alerts.paste.actionMismatch.title',
    body: 'alerts.paste.actionMismatch.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.PASTE_SUCCESS]: {
    title: 'alerts.paste.success.title',
    body: 'alerts.paste.success.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.UNDO_WORKFLOW_CHANGE_SUCCESS]: {
    title: 'alerts.undo.success.title',
    body: 'alerts.undo.success.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.REDO_WORKFLOW_CHANGE_SUCCESS]: {
    title: 'alerts.redo.success.title',
    body: 'alerts.redo.success.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.UNDO_WORKFLOW_CHANGE_FAIL_GENERIC]: {
    title: 'alerts.undo.failGeneric.title',
    body: 'alerts.undo.failGeneric.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.REDO_WORKFLOW_CHANGE_FAIL_GENERIC]: {
    title: 'alerts.redo.failGeneric.title',
    body: 'alerts.redo.failGeneric.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.ACTION_SET_DELETE_SUCCESS]: {
    title: 'alerts.actionSetDeleteSuccess.title',
    body: 'alerts.actionSetDeleteSuccess.body',
    type: MessageTypes.SUCCESS
  },
  [AlertTypes.ACTION_SET_DELETE_FAIL]: {
    title: 'alerts.defaultAlert.title',
    body: 'alerts.actionSetDeleteFail.body',
    type: MessageTypes.DANGER
  },
  [AlertTypes.ACTION_LIMIT_REACHED]: {
    title: 'alerts.actionLimitReached.title',
    body: messageOptions => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.actionLimitReached.body",
      options: {
        limit: messageOptions.limit
      }
    }),
    type: MessageTypes.DANGER
  }
};
export default AlertDefinitions;